import {Sprite_TilingFrame} from "./TilingFrame.sprite";

export class Sprite_ItemExtraInfo extends KDCore.Sprite {
  constructor(extraInfo) {
    super();
    this.extraInfo = extraInfo;
    this._extraInfoText = this._prepareDescriptionText(this.extraInfo.info.text);
    this._createContent();
  }

  _prepareDescriptionText(text) {
    text = text.replaceAll("\"", "");
    text = text.replaceAll("\\\\", "\\");
    text = text.replace(/\\n+/g, ' ');
    return text;
  }

  _createContent() {
    this._createInfoBlock();
    if (String.any(this.extraInfo.picture.imgName)) {
      return this._creactePictureBlock();
    }
  }

  _createInfoBlock() {
    const s = this.extraInfo.info;
    this.textBack = new Sprite_TilingFrame(s.size.w, s.size.h, 'ExtraInfoFrame');
    this.addChild(this.textBack);
    this.textBack.move(s.position);
    this._createText();
    this._drawText();
  }

  _createText() {
    const sprite = this.extraInfo.info;
    this._description = new Window_Base(0, 0, sprite.size.w, sprite.size.h);

    const resetFont = function() {
      if (String.any(sprite.font.face)) {
        this.contents.fontFace = sprite.font.face;
      }
      this.contents.fontSize = sprite.font.size;
      this.contents.fontItalic = sprite.font.italic;
      this.resetTextColor();
    };

    this._description.resetFontSettings = resetFont.bind(this._description);
    this._description.setBackgroundType(2);
    this.textBack.addChild(this._description);
  }

  _drawText() {
    this._description.contents.clear();
    this._description.resetFontSettings();
    this._description.drawTextExWithWordWrap(this._extraInfoText, 0, 0, this.extraInfo.info.size.w - 10);
  }

  _creactePictureBlock() {
    const sprite = this.extraInfo.picture;
    this.picBack = new Sprite_TilingFrame(sprite.size.w, sprite.size.h, 'ExtraInfoFrame');
    this.addChild(this.picBack);
    this.picBack.move(sprite.position);
    return KDCore.Utils.loadImageAsync('pictures', sprite.imgName).then(this._drawPicture.bind(this));
  }

  _drawPicture(sBitmap) {
    const size = this.extraInfo.picture.size;
    const imgSpr = KDCore.Sprite.FromBitmap(size.w, size.h);
    imgSpr.bitmap.drawOnMe(sBitmap, 4, 4, size.w - 8, size.h - 8);

    this.picBack.content.addChild(imgSpr);
  }
}
